// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1eQWC","head":"Table_head__1MLSz","col":"Table_col__3rsch"};